import { CanActivateFn } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  // console.log('Route = ', route);
  console.debug('State = ', state.url);
  if (state.url === '/scaned-receipts') {
    return true;
  } else {
    return true;
  }
};
